<!-- Üksiku uudise vaheleht -->
<template>
  <v-sheet class="main-content">
    <v-sheet class="mx-auto" v-if="isLoading">
      <v-skeleton-loader type="heading, image, paragraph"></v-skeleton-loader>
    </v-sheet>
    <v-sheet v-else class="d-flex w-100 mx-auto post-body flex-column">
      <button
          v-if="$store.state.isLoggedIn"
          type="button"
          class="post-edit-btn"
          aria-label="Muuda postitust"
          @click="$router.push('/uudised/editpost/' + post.id)"
      >
        <i class="fa fa-pen-to-square"></i>
      </button>
      <div class="post-content">
        <v-list-item-subtitle>{{ this.getDate(post.date) }}</v-list-item-subtitle>
        <h2 class="py-6 text-center">{{ getHeader(post) }}</h2>
        <img v-if="getImageSrc(post.image)" class="img-shadow" alt="Postituse pilt" :src="getImageSrc(post.image)" @error="useDefaultImage" />
        <img v-else class="default-logo" alt="lõhnakas logo" :src="defaultLogo" />
        <div class="tiptap tiptap-editor" v-html=getBody(post)></div>
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import { mapGetters } from 'vuex';
import defaultLogo from "@/assets/images/lohnakas.webp";

export default {
  name: "ViewPost",
  components: {PageHeader},
  data() {
    return {
      post: [],
      isLoading: true,
      defaultLogo,
    }
  },
  computed: {
    ...mapGetters([
      'formatDate',
    ]),
  },
  methods: {
    getImageSrc(image) {
      if (typeof image !== 'string') return '';

      const normalized = image.trim();
      if (!normalized) return '';

      const invalidValues = ['null', 'undefined', '[]', '{}'];
      return invalidValues.includes(normalized.toLowerCase()) ? '' : normalized;
    },
    useDefaultImage(event) {
      event.target.src = this.defaultLogo;
      event.target.classList.add('default-logo');
    },
    fetchAPost(id) {
      fetch(`${process.env.VUE_APP_SERVER_URL}/api/posts/${id}`)
          .then((response) => response.json())
          .then((data) => {
            this.post = data;
            this.isLoading = false;
          })
          .catch((err) => console.log(err.message));
    },
    getDate(date) {
      return this.formatDate(date);
    },
    getHeader(content) {
      return (this.$i18n.locale === 'en' && content.header_en !== null) ? content.header_en : (this.$i18n.locale === 'ru' && content.header_ru !== null) ? content.header_ru : content.header;
    },
    getBody(content) {
      return (this.$i18n.locale === 'en' && content.body_en !== null) ? content.body_en : (this.$i18n.locale === 'ru' && content.body_ru !== null) ? content.body_ru : content.body;
    }
  },
  mounted() {
    this.fetchAPost(this.$route.params.id);
  }
}
</script>

<style scoped>
img {
  width: 100%;
  height: auto;
  object-fit: cover;
  padding: 20px 0;
}

.img-shadow {
  width: 100%;
  height: 100%;
}

.v-list-item-title {
  white-space: break-spaces;
  line-height: 1em;
}

.post-body {
  border-width: thin;
  max-width: 940px;
  margin-top: 150px;
  position: relative;
}

ul {
  padding: 20px !important;
}

.post-content {
  padding: 4em;
}

.post-edit-btn {
  position: absolute;
  left: 50%;
  top: -24px;
  transform: translateX(-50%);
  z-index: 20;
  border: 0;
  background: transparent;
  color: #000;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

@media (max-width: 940px) {
  .post-body {
    border: none;
    margin-top: 20px;
    padding-top: 22px;
  }

  .post-edit-btn {
    top: 4px;
  }

  .post-content {
    padding: 0;
  }
}
</style>
